import store from '../../store'

export function openWhiteboardModal(isNewWhiteboard,embedId,docId) {	
	store.dispatch({type:'SHOW_WHITEBOARD_MODAL',isNewWhiteboard:isNewWhiteboard,embedId:embedId,docId:docId})
}
